var _circle, _g, _path, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7290_57985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7290_57985)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -64.3481,
    y: -18.2609,
    width: 151.304,
    height: 100.87,
    fill: "url(#paint0_linear_7290_57985)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5C18.625 20.5 17.4479 20.0104 16.4688 19.0312C15.4896 18.0521 15 16.875 15 15.5C15 14.125 15.4896 12.9479 16.4688 11.9688C17.4479 10.9896 18.625 10.5 20 10.5C21.375 10.5 22.5521 10.9896 23.5312 11.9688C24.5104 12.9479 25 14.125 25 15.5C25 16.875 24.5104 18.0521 23.5312 19.0312C22.5521 20.0104 21.375 20.5 20 20.5ZM10 30.5V27C10 26.2917 10.1823 25.6406 10.5469 25.0469C10.9115 24.4531 11.3958 24 12 23.6875C13.2917 23.0417 14.6042 22.5573 15.9375 22.2344C17.2708 21.9115 18.625 21.75 20 21.75C21.375 21.75 22.7292 21.9115 24.0625 22.2344C25.3958 22.5573 26.7083 23.0417 28 23.6875C28.6042 24 29.0885 24.4531 29.4531 25.0469C29.8177 25.6406 30 26.2917 30 27V30.5H10Z",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.5,
    stroke: "url(#paint1_linear_7290_57985)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7290_57985",
    x1: 11.304,
    y1: -18.2609,
    x2: 11.304,
    y2: 82.6087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7290_57985",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D57A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA858",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar-default.9655d01099064de92d802b62a9819573.svg";
export { ForwardRef as ReactComponent };